<template>
  <div class="row">
    <div class="col-lg-4 col-md-5">
      <user-card></user-card>
      <members-card></members-card>
    </div>
    <div class="col-lg-8 col-md-7">
      <competencias-card></competencias-card>
      <power-university></power-university>
      <!-- <info-video></info-video> -->
    </div>
  </div>
</template>
<script>
  import EditProfileForm from './UserProfile/EditProfileForm.vue'
  import UserCard from './UserProfile/UserCard.vue'
  import CompetenciasCard from './UserProfile/CompetenciasCard.vue'
  import InfoVideo from './UserProfile/InfoVideo'
  import PowerUniversity from './UserProfile/PowerUniversity.vue'
  import MembersCard from './UserProfile/MembersCard.vue'

  export default {
    components: {
      EditProfileForm,
      UserCard,
      CompetenciasCard,
      MembersCard,
      InfoVideo,
      PowerUniversity
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile.vue